
import { YoungQuestion } from '@/types/personality';

// Questions for Impaired Autonomy & Performance Domain
export const impairedAutonomyQuestions: YoungQuestion[] = [
  // Esquema: Fracasso
  {
    id: 16,
    text: "Quase nada do que faço no trabalho (ou na escola) é tão bom quanto o que os outros são capazes de fazer.",
    domain: "impaired_autonomy",
    schema: "failure"
  },
  {
    id: 17,
    text: "Sou incompetente quando se trata de realizações/conquistas.",
    domain: "impaired_autonomy",
    schema: "failure"
  },
  {
    id: 18,
    text: "A maioria das pessoas é mais capaz do que eu em áreas de trabalho e realização.",
    domain: "impaired_autonomy",
    schema: "failure"
  },
  
  // Esquema: Dependência/Incompetência
  {
    id: 19,
    text: "Não me sinto capaz de lidar com responsabilidades do dia a dia sem uma ajuda considerável dos outros.",
    domain: "impaired_autonomy",
    schema: "dependence"
  },
  {
    id: 20,
    text: "Preciso que outras pessoas me ajudem a tomar decisões diárias importantes.",
    domain: "impaired_autonomy",
    schema: "dependence"
  },
  {
    id: 21,
    text: "Não me sinto capaz de lidar com os problemas da vida do dia a dia.",
    domain: "impaired_autonomy",
    schema: "dependence"
  },
  
  // Esquema: Vulnerabilidade
  {
    id: 22,
    text: "Não consigo parar de me preocupar que uma catástrofe (natural, criminal, médica ou financeira) vai acontecer.",
    domain: "impaired_autonomy",
    schema: "vulnerability"
  },
  {
    id: 23,
    text: "Frequentemente me preocupo que posso ter uma doença grave, mesmo quando não há nenhuma evidência médica disso.",
    domain: "impaired_autonomy",
    schema: "vulnerability"
  },
  {
    id: 24,
    text: "Sinto que o mundo é um lugar perigoso.",
    domain: "impaired_autonomy",
    schema: "vulnerability"
  },
  
  // Esquema: Emaranhamento
  {
    id: 25,
    text: "Não consegui desenvolver uma identidade separada dos meus pais ou parceiro.",
    domain: "impaired_autonomy",
    schema: "enmeshment"
  },
  {
    id: 26,
    text: "Sempre sinto que não tenho uma identidade separada das pessoas que são importantes para mim.",
    domain: "impaired_autonomy",
    schema: "enmeshment"
  },
  {
    id: 27,
    text: "É muito difícil para mim manter uma vida própria separada das vidas das pessoas que são importantes para mim.",
    domain: "impaired_autonomy",
    schema: "enmeshment"
  }
];
